export const SET_PENDING_TASKS = (state, tasks) => {
    state.pendingTasks = tasks;
}

export const SET_LOADING_TASKS = (state, loading) => {
    state.loadingTasks = loading;
}

